export enum Subject {
  App = 'app',
  Target = 'target',
  Scope = 'scope',
}

export enum Action {
  Create = 'create',
  Delete = 'delete',
  Edit = 'edit',
  View = 'view',
}

export enum Roles {
  EditUser = 'rtg-oim.edit-user',
  ReadOnlyUser = 'rtg-oim.read-only-user',
  SystemUser = 'rtg-oim.system-user',
}

export interface Permission {
  role: Roles;
  subject: Subject;
  action: Action;
}
